export const LANGUAGE_MENU = [
  {
    name: 'English',
    native: 'English',
    iso: 'en-US',
    img: '/img/flags-rounded/united-kingdom.svg',
  },
  {
    name: 'Turkish',
    native: 'Türkçe',
    iso: 'tr-TR',
    img: '/img/flags-rounded/turkey.svg',
  },
  {
    name: 'German',
    native: 'Deutsch',
    iso: 'de-DE',
    img: '/img/flags-rounded/germany.svg',
  },
  {
    name: 'Spanish',
    native: 'Español',
    iso: 'es-ES',
    img: '/img/flags-rounded/spain.svg',
  },
  {
    name: 'French',
    native: 'Français',
    iso: 'fr-FR',
    img: '/img/flags-rounded/france.svg',
  },
  {
    name: 'Italian',
    native: 'Italiano',
    iso: 'it-IT',
    img: '/img/flags-rounded/italy.svg',
  },
  {
    name: 'Polish',
    native: 'Polski',
    iso: 'pl-PL',
    img: '/img/flags-rounded/republic-of-poland.svg',
  },
  {
    name: 'Greek',
    native: 'Ελληνικά',
    iso: 'el-GR',
    img: '/img/flags-rounded/greece.svg',
  },
  {
    name: 'Czech',
    native: 'čeština',
    iso: 'cs-CZ',
    img: '/img/flags-rounded/czech-republic.svg',
  },
  {
    name: 'Danish',
    native: 'Dansk',
    iso: 'da-DK',
    img: '/img/flags-rounded/denmark.svg',
  },
  {
    name: 'Finnish',
    native: 'Suomalainen',
    iso: 'fi-FI',
    img: '/img/flags-rounded/finland.svg',
  },
  {
    name: 'Bulgarian',
    native: 'български',
    iso: 'bg-BG',
    img: '/img/flags-rounded/bulgaria.svg',
  },
  {
    name: 'Swedish',
    native: 'Svenska',
    iso: 'sv-SE',
    img: '/img/flags-rounded/sweden.svg',
  },
  {
    name: 'Lithuanian',
    native: 'Lietuvis',
    iso: 'lt-LT',
    img: '/img/flags-rounded/lithuania.svg',
  },
  {
    name: 'Portuguese',
    native: 'Português',
    iso: 'pt-PT',
    img: '/img/flags-rounded/portugal.svg',
  },
  {
    name: 'Russian',
    native: 'Русский',
    iso: 'ru-RU',
    img: '/img/flags-rounded/russia.svg',
  },
  {
    name: 'Ukrainian',
    native: 'Українська',
    iso: 'uk-UA',
    img: '/img/flags-rounded/ukraine.svg',
  },
  {
    name: 'Azerbaijani',
    native: 'Azərbaycan',
    iso: 'az-AZ',
    img: '/img/flags-rounded/azerbaijan.svg',
  },
  {
    name: 'Kazakh',
    native: 'Қазақ',
    iso: 'kk-KZ',
    img: '/img/flags-rounded/kazakhstan.svg',
  },
  {
    name: 'Uzbek',
    native: "O'zbek",
    iso: 'uz-UZ',
    img: '/img/flags-rounded/uzbekistn.svg',
  },
  {
    name: 'Armenian',
    native: 'հայերեն',
    iso: 'hy-AM',
    img: '/img/flags-rounded/armenia.svg',
  },
  {
    name: 'Hebrew',
    native: 'עִברִית',
    iso: 'he-IL',
    img: '/img/flags-rounded/israel.svg',
  },
  {
    name: 'Japanese',
    native: '日本語',
    iso: 'ja-JP',
    img: '/img/flags-rounded/japan.svg',
  },
  {
    name: 'Hindi',
    native: 'हिन्दी',
    iso: 'hi-IN',
    img: '/img/flags-rounded/india.svg',
  },
  {
    name: 'Chinese',
    native: '简体中文',
    iso: 'zh-CN',
    img: '/img/flags-rounded/china.svg',
  },
  {
    name: 'Chinese (Hong Kong)',
    native: '繁體中文 (香港)',
    iso: 'zh-HK',
    img: '/img/flags-rounded/hong-kong.svg',
  },
  {
    name: 'Vietnamese',
    native: 'Tiếng Việt',
    iso: 'vi-VN',
    img: '/img/flags-rounded/vietnam.svg',
  },
  {
    name: 'Korean',
    native: '한국어',
    iso: 'ko-KR',
    img: '/img/flags-rounded/south-korea.svg',
  },
  {
    name: 'Arabic (U.A.E.)',
    native: 'العربية (الإمارات العربية المتحدة)',
    iso: 'ar-AE',
    img: '/img/flags-rounded/united-arab-emirates.svg',
  },
  {
    name: 'Arabic (Saudi Arabia)',
    native: 'العربية (المملكة العربية السعودية)',
    iso: 'ar-SA',
    img: '/img/flags-rounded/saudi-arabia.svg',
  },
];
